import buttons from 'i18n/en/forms/buttons'
import radioButtons from 'i18n/en/forms/radio_buttons'
import saveStatusChecks from 'i18n/en/forms/save_status_checks'
import validations from 'i18n/en/forms/validations'

export default {
  ...buttons,
  ...radioButtons,
  ...saveStatusChecks,
  ...validations
}
